import { CreateContactSteps } from '@/domains/contacts/store/types/createContactTypes';

export const checkContactInformation = (
  contactInformation?: CreateContactSteps['contactInfo'],
): CreateContactSteps['contactInfo'] | null => {
  if (!contactInformation) return null;

  const { contactPreferenceId, contactPreference, ...rest } = contactInformation;

  // in case contact preference option is empty "null"/"-" and no other data is entered
  if (contactInformation.contactPreferenceId === 0 && !Object.values(rest).some((field) => field)) {
    return null;
  }

  return Object.values(contactInformation).some((field) => field) ? contactInformation : null;
};
